import { DomainSearchSuiteModule, SearchRecommendationModule } from '@wix/domains-search-suite';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import React from 'react';
import { SearchGateHomeContent } from '../../SearchGateHome';
import { SiteLevelGateHomeOptimizedContent } from '../../SiteLevelGateOptimized';
import { ViewMode } from '../../../types';
import { useIsGateRevamp3Enabled } from '../../../hooks/useIsGateRevamp3Enabled';
export const FunnelGateHomePage = _ref => {
  var _getPremiumEssentials;
  let handlers = _ref.handlers,
    externalViewer = _ref.externalViewer;
  const siteName = (_getPremiumEssentials = getPremiumEssentialsSafe()) == null ? void 0 : _getPremiumEssentials.siteName;
  const titleKey = siteName ? undefined : 'domain_search_gate.domain_gate.account_level.page.title';
  const isRevampedGate = useIsGateRevamp3Enabled();
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      enabledActions: ['alreadyAssignedToThisSite', 'alreadyAssigned', 'floatingDomain'],
      handlers,
      siteInfo: {
        externalViewer: Boolean(externalViewer)
      },
      uiConfig: {
        fullPage: true
      }
    }
  }, /*#__PURE__*/React.createElement(SearchRecommendationModule.Provider, null, isRevampedGate ? /*#__PURE__*/React.createElement(SiteLevelGateHomeOptimizedContent, {
    viewMode: ViewMode.FUNNEL_GATE,
    titleKey: titleKey
  }) : /*#__PURE__*/React.createElement(SearchGateHomeContent, {
    hideBackButton: true,
    viewMode: ViewMode.FUNNEL_GATE,
    titleKey: titleKey
  })));
};
//# sourceMappingURL=FunnelGateHomePage.js.map